var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownLimitOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FD6D00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.0003,
    cy: 16.0004,
    r: 12.2353,
    fill: "url(#paint0_linear_2530_51667)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 9.41211C16.1246 9.41211 16.2443 9.46169 16.3326 9.54994C16.4208 9.63819 16.4704 9.75789 16.4704 9.8827V20.982L19.4313 18.0201C19.5197 17.9317 19.6395 17.8821 19.7645 17.8821C19.8895 17.8821 20.0093 17.9317 20.0977 18.0201C20.1861 18.1085 20.2357 18.2283 20.2357 18.3533C20.2357 18.4783 20.1861 18.5981 20.0977 18.6865L16.333 22.4512C16.2893 22.495 16.2373 22.5298 16.1802 22.5535C16.123 22.5772 16.0617 22.5894 15.9998 22.5894C15.9379 22.5894 15.8766 22.5772 15.8194 22.5535C15.7623 22.5298 15.7103 22.495 15.6666 22.4512L11.9019 18.6865C11.8136 18.5981 11.7639 18.4783 11.7639 18.3533C11.7639 18.2283 11.8136 18.1085 11.9019 18.0201C11.9903 17.9317 12.1101 17.8821 12.2351 17.8821C12.3601 17.8821 12.4799 17.9317 12.5683 18.0201L15.5292 20.982V9.8827C15.5292 9.75789 15.5788 9.63819 15.667 9.54994C15.7553 9.46169 15.875 9.41211 15.9998 9.41211Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2530_51667",
    x1: 16.0003,
    y1: 3.76514,
    x2: 16.0003,
    y2: 28.2357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD6D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D76107"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownLimitOrderIcon);
export default __webpack_public_path__ + "static/media/arrow-down-limit-order-icon.1be50ffc8db146a5384dd518ebd0f74b.svg";
export { ForwardRef as ReactComponent };